<template>
  <div>
    <PSecondaryButton appkit-icon="icon-upload-outline" @click="open"
      >Import</PSecondaryButton
    >
    <ImportSupplierDialog
      :open-dialog="isDialogOpen"
      @close-dialog="close"
      @suppliers-uploaded="onSuppliersUploaded"
    />

    <PModalBox
      :open-dialog="isWarningDialogOpen"
      header="Warning"
      size="small"
      @close-dialog="close"
    >
      <template #content>
        The suppliers you already have uploaded will be overwritten. Do you want
        to continue?
      </template>
      <template #leftbutton>
        <PSecondaryButton @click="close">Cancel</PSecondaryButton>
      </template>
      <template #rightbutton>
        <PPrimaryButton @click="continueOperation">Continue</PPrimaryButton>
      </template>
    </PModalBox>
  </div>
</template>

<script setup lang="ts">
import ImportSupplierDialog from "@/views/supplier-registry/ImportSupplierDialog.vue";
import { ref } from "vue";
import PPrimaryButton from "@/components/custom/buttons/PPrimaryButton.vue";
import PSecondaryButton from "@/components/custom/buttons/PSecondaryButton.vue";
import PModalBox from "@/components/custom/PModalBox.vue";

const props = defineProps<{
  isOverwriting?: boolean;
}>();

const emit = defineEmits<{
  (e: "suppliersUploaded"): void;
}>();

const isDialogOpen = ref(false);
const isConflictDialogOpen = ref(false);
const isWarningDialogOpen = ref(false);

const open = () => {
  if (props.isOverwriting) {
    isWarningDialogOpen.value = true;
  } else {
    isDialogOpen.value = true;
  }
};
const close = () => {
  isDialogOpen.value = false;
  isConflictDialogOpen.value = false;
  isWarningDialogOpen.value = false;
};

const continueOperation = () => {
  isWarningDialogOpen.value = false;
  isDialogOpen.value = true;
};

function onSuppliersUploaded(): void {
  emit("suppliersUploaded");
  close();
}
</script>
